import React from 'react';
import PropTypes from 'prop-types';
import { Table, Checkbox } from 'antd';

const ColumnConfig = ({ columns, onColumnUpdate }) => {
  const coltoFiledMap = columns.map((col) => {
    return {
      id: col.key,
      fieldName: col.title,
      visible: col.visible,
      canExclude: col.canExclude,
    };
  });

  // const [dataSource, setDataSource] = useState(coltoFiledMap);

  // const dataSource = coltoFiledMap

  const onChange = (visible, record) => {
    for (var i in columns) {
      if (columns[i].key === record.id) {
        columns[i].visible = visible;
         break;
      }
    }
    console.log('**************', visible, record, columns);
    onColumnUpdate(columns);
  };

  const fields = [
    {
      dataIndex: 'fieldName',
      className: 'drag-visible',
    },
    {
      dataIndex: 'canExclude',
      render: (value, record) => {        
        return (
          <Checkbox
            onChange={(e) => onChange(e.target.checked, record)}
            defaultChecked={record.visible}
            disabled={!record.canExclude}
          />
        );
      },
    },
  ];

  return (
    <Table
      showHeader={false}
      pagination={false}
      dataSource={coltoFiledMap}
      columns={fields}
      size="small"
      rowKey="index"
    />
  );
};

ColumnConfig.propTypes = {
  columns: PropTypes.array.isRequired,
  onColumnUpdate: PropTypes.func.isRequired,
};

export default ColumnConfig;
